module.exports = __webpack_public_path__ + "img/support-wpp.b806078f.svg";